import { useTheme } from "@emotion/react";
import { Add } from "@mui/icons-material";
import { Box, Stack, Typography, CircularProgress } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import Filter from "./Filter";
import { useGlobalSpeciesGender } from "hooks/useGlobalSpeciesGender";

const AvatarCreator = ({ type, images, setImages, maxFiles }) => {
  const theme = useTheme();

  const { species, gender } = useGlobalSpeciesGender();
  const [_species, setspecies] = useState(species);
  const [_gender, setgender] = useState(gender);

  // Main state for images

  const [selectedIndex, setSelectedIndex] = useState(null);

  const inputRef = useRef();

  // Handle file selection
  const onChange = async (e) => {
    const selectedFiles = Array.from(e.target.files).filter(
      (file) => file.type === "image/jpeg" || file.type === "image/png"
    );
    let newFiles = [...images];

    if (selectedFiles.length > 1) {
      let fileIdx = 0;
      for (let i = 0; i < maxFiles && fileIdx < selectedFiles.length; i++) {
        if (!newFiles[i]) {
          newFiles[i] = selectedFiles[fileIdx];
          fileIdx++;
        }
      }
    } else if (selectedFiles.length === 1 && selectedIndex !== null) {
      newFiles[selectedIndex] = selectedFiles[0];
    }

    setImages(newFiles);
    setSelectedIndex(null);
  };

  // Open dialog and track which box was clicked
  const openFileDialog = (idx) => {
    setSelectedIndex(idx);
    inputRef.current.value = "";
    inputRef.current.click();
  };

  const handleSetSpecies = (event, value) => {
    if (value !== null) setspecies(value);
  };

  const handleSetGender = (event, value) => {
    if (value !== null) setgender(value);
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png"
        multiple
        style={{ display: "none" }}
        onChange={onChange}
      />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 0.5, sm: 1, md: 1 }}
        useFlexGap
        sx={{ flexWrap: "wrap", justifyContent: "center", marginTop: "30px" }}
      >
        <Filter
          species={_species}
          gender={_gender}
          handleSetSpecies={handleSetSpecies}
          handleSetGender={handleSetGender}
          position={"center"}
        />
        {type === "quick" ? (
          <>QUICK</>
        ) : (
          <>
            <Typography
              fontSize={{ xs: "0.8em", sm: "1em" }}
              sx={{ wordBreak: "break-word" }}
            >
              Upload {maxFiles} photos to help us train AI and create your
              personalized AI Avatar{" "}
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 0.5, sm: 1, md: 1 }}
              useFlexGap
              width={{ xs: "auto", sm: 650, md: 650 }}
              sx={{
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              {images.map((file, idx) => (
                <Box
                  key={idx}
                  sx={{
                    width: 200,
                    height: 200,
                    backgroundColor: "#e4e4e4",
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    position: "relative",
                  }}
                  onClick={() => openFileDialog(idx)}
                >
                  {file ? (
                    <>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={`uploaded-${idx}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 8,
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Add
                        fontSize="large"
                        sx={{
                          color: theme.palette.yellows[700],
                          fontWeight: 800,
                        }}
                      />
                      <Typography
                        sx={{
                          color: theme.palette.yellows[700],
                          fontSize: "1rem",
                          fontWeight: 800,
                        }}
                      >
                        add photo
                      </Typography>
                    </>
                  )}
                </Box>
              ))}
            </Stack>
          </>
        )}
      </Stack>
    </>
  );
};

export default AvatarCreator;
